import { Price } from '@common/components';
import { Price as PriceType } from 'shared-types/Common';
import React, { FC } from 'react';
import { useTranslations } from '@lang';
import { PriceWrapperRed } from './styles';
import { PriceWrapper } from '../styles';

type PromosTotalsProps = {
  discountTotals?: {
    standardTotal: PriceType;
    discountedTotal: PriceType;
  } | null;
};

export const PromosTotals: FC<PromosTotalsProps> = ({ discountTotals }) => {
  const { t } = useTranslations();
  const discountAmount =
    (discountTotals?.standardTotal?.amount || 0) - (discountTotals?.discountedTotal?.amount || 0);
  return discountTotals ? (
    <>
      <PriceWrapper>
        <div>{t('basket.subtotal')}</div>
        <Price price={discountTotals?.standardTotal} />
      </PriceWrapper>
      <PriceWrapperRed>
        <div>{t('basket.discount')}</div>
        <Price
          price={{
            currencyCode: discountTotals?.standardTotal?.currencyCode as string,
            amount: discountAmount,
          }}
        />
      </PriceWrapperRed>
      <PriceWrapper>
        <div>{t('basket.orderTotal')}</div>
        <Price price={discountTotals?.discountedTotal} />
      </PriceWrapper>
    </>
  ) : null;
};
